import * as actionTypes from "./actionTypes";

export const getCODMaxAmount = () => {
  return {
    type: actionTypes.GET_COD_MAX_AMOUNT,
  };
};

export const getCODMaxAmountSuccess = (data) => {
  return {
    type: actionTypes.GET_COD_MAX_AMOUNT_SUCCESS,
    data,
  };
};

export const getCODMaxAmountFail = () => {
  return {
    type: actionTypes.GET_COD_MAX_AMOUNT_FAIL,
  };
};

export const restaurantDirectCheckout = (data, isCOD = false) => {
  return {
    type: actionTypes.RESTAURANT_DIRECT_CHECKOUT,
    data,
    isCOD,
  };
};

export const restaurantDirectCheckoutSuccess = (data) => {
  return {
    type: actionTypes.RESTAURANT_DIRECT_CHECKOUT_SUCCESS,
    data,
  };
};

export const restaurantDirectCheckoutFail = (data = {}) => {
  return {
    type: actionTypes.RESTAURANT_DIRECT_CHECKOUT_FAIL,
    data,
  };
};

export const checkRiderAvailability = () => {
  return {
    type: actionTypes.CHECK_RIDER_AVAILABILITY,
  };
};

export const checkRiderAvailabilitySuccess = (data) => {
  return {
    type: actionTypes.CHECK_RIDER_AVAILABILITY_SUCCESS,
    data,
  };
};

export const checkRiderAvailabilityFail = (data) => {
  return {
    type: actionTypes.CHECK_RIDER_AVAILABILITY_FAIL,
    data,
  };
};

export const checkOrderTypeAndTime = (data) => {
  return {
    type: actionTypes.CHECK_ORDER_TYPE_AND_TIME,
    data,
  };
};

export const checkOrderTypeAndTimeSuccess = (data) => {
  return {
    type: actionTypes.CHECK_ORDER_TYPE_AND_TIME_SUCCESS,
    data,
  };
};

export const checkOrderTypeAndTimeFail = (data) => {
  return {
    type: actionTypes.CHECK_ORDER_TYPE_AND_TIME_FAIL,
    data,
  };
};

export const loadAvailableOrderTime = (data) => {
  return { type: actionTypes.LOAD_AVAILABLE_ORDER_TIME, data };
};

export const loadAvailableOrderTimeSuccess = (data) => {
  return { type: actionTypes.LOAD_AVAILABLE_ORDER_TIME_SUCCESS, data };
};

export const loadAvailableOrderTimeFail = () => {
  return { type: actionTypes.LOAD_AVAILABLE_ORDER_TIME_FAIL };
};

export const getDeliveryETA = (data) => {
  return { type: actionTypes.GET_DELIVERY_ETA, data };
};

export const getDeliveryETASuccess = (data) => {
  return { type: actionTypes.GET_DELIVERY_ETA_SUCCESS, data };
};

export const getDeliveryETAFail = () => {
  return { type: actionTypes.GET_DELIVERY_ETA_FAIL };
};

export const getSpecialArea = (data) => {
  return { type: actionTypes.GET_SPECIAL_AREA, data };
};

export const getSpecialAreaSuccess = (data) => {
  return { type: actionTypes.GET_SPECIAL_AREA_SUCCESS, data };
};

export const getSpecialAreaFail = () => {
  return { type: actionTypes.GET_SPECIAL_AREA_FAIL };
};

export const dineInPayLater = (data) => {
  return {
    type: actionTypes.RESTAURANT_DINE_IN_PAY_LATER,
    data,
  };
};
export const dineInPayLaterSuccess = () => {
  return {
    type: actionTypes.RESTAURANT_DINE_IN_PAY_LATER_SUCCESS,
  };
};
export const dineInPayLaterFail = (data) => {
  return {
    type: actionTypes.RESTAURANT_DINE_IN_PAY_LATER_FAIL,
    data,
  };
};
